import { Icon, Tooltip } from "@mui/material";
import {
  GridActionsCellItem,
  GridAlignment,
  GridColumns,
  GridRenderCellParams,
  GridRowParams,
} from "@mui/x-data-grid";
import { IQualitaExt } from "../../../../../interfaces/lotto/attributes/models";
import { ICreateColumnsPros } from "./interfaces";
import { CellWebPublished } from "./tableCells";

const i18_PATH = "qualita.list.columns.";

export const createColumns = ({
  t,
  onEdit,
}: ICreateColumnsPros): GridColumns<IQualitaExt> => [
  {
    field: "actions",
    type: "actions",
    align: "left" as GridAlignment,
    hideable: false,
    maxWidth: 100,
    getActions: (params: GridRowParams<IQualitaExt>) => [
      <GridActionsCellItem
        placeholder={null}
        onResize={null}
        onResizeCapture={null}
        onPointerEnterCapture={null}
        onPointerLeaveCapture={null}
        icon={
          <Tooltip title="Modifica">
            <Icon className="fa-light fa-pen" sx={{ overflow: "visible" }} />
          </Tooltip>
        }
        label="Edit"
        onClick={() => onEdit(params.id as number)}
        showInMenu={undefined}
      />,
    ],
  },
  {
    field: "ext.pubblicatoSuWeb",
    headerName: "",
    valueGetter: ({ row }) => row.ext?.pubblicatoSuWeb,
    renderCell: (params: GridRenderCellParams) => {
      console.log({ params });
      return <CellWebPublished published={params.value} />;
    },
    width: 40,
  },
  {
    field: "nome",
    headerName: t(`${i18_PATH}Nome`) ?? undefined,
    width: 160,
  },
  {
    field: "materiale.nome",
    headerName: t(`${i18_PATH}Materiale`) ?? undefined,
    valueGetter: ({ row }) => row.materiale?.nome,
    width: 160,
  },
  {
    field: "fondo.nome",
    headerName: t(`${i18_PATH}Colore`) ?? undefined,
    valueGetter: ({ row }) => row.fondo?.nome,
    width: 160,
  },
  {
    field: "utilizzo",
    headerName: t(`${i18_PATH}Utilizzo`) ?? undefined,
    valueGetter: ({ row }) =>
      (row?.utilizzo ?? []).map((item) => item.nome).join(", "),
    width: 160,
  },
  {
    field: "finiture",
    headerName: t(`${i18_PATH}Finiture`) ?? undefined,
    valueGetter: ({ row }) =>
      (row?.finiture ?? []).map((item) => item.nome).join(", "),
    width: 160,
  },
  {
    field: "ext.descrizione",
    headerName: t(`${i18_PATH}Descrizione`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.descrizione,
    flex: 1,
    minWidth: 300,
  },
];
